import {getPointBetweenPoints, getPointDistance, orientation} from "../helpers/sqftHelper";

const setLinePoints = (movingLine, newFrom, newTo) => {
  movingLine.from.x = newFrom.x;
  movingLine.from.y = newFrom.y;
  movingLine.to.x = newTo.x;
  movingLine.to.y = newTo.y;
};

/**
 * Given a three lines detects moving points and sets correct new points X and Y values.
 * @param {Object} movingLine current moving line
 * @param {Object} nextLine
 * @param {Object} prevLine
 * @param {number} baseLineDistance -state value, that is overwritten on each mouseDown event
 * @param {number} yDiff Y difference of mouse move
 * @param {number} lineOrientation movingLine orientation
 */
export default function (
  movingLine,
  nextLine,
  prevLine,
  baseLineDistance,
  yDiff,
  lineOrientation
) {
  let newFrom = {}, newTo = {}, diff;

  // 1) move line
  switch(lineOrientation) {
    case orientation.SOUTHEAST:
    case orientation.NORTHEAST:
      diff = -yDiff;
      break;
    case orientation.SOUTHWEST:
    case orientation.NORTHWEST:
      diff = yDiff;
      break;
  }
  newFrom = getPointBetweenPoints(movingLine.from, prevLine.from, diff);
  newTo = getPointBetweenPoints(movingLine.to, nextLine.to, diff);
  setLinePoints(movingLine, newFrom, newTo);
  const pointDistance2 = getPointDistance(newFrom, newTo);

  // 2) fix points corrections
  if (baseLineDistance !== pointDistance2) {
    switch(lineOrientation) {
      case orientation.SOUTHWEST:
        if (pointDistance2 < baseLineDistance) {
          const delta = (baseLineDistance - pointDistance2) / 4; //for ex. 26 - 25.4 = 0.6
          newFrom = {x: movingLine.from.x + delta, y: movingLine.from.y - delta};
          newTo = {x: movingLine.to.x - delta, y: movingLine.to.y + delta};
        } else {
          const delta = (pointDistance2 - baseLineDistance) / 4; //for ex. 26 - 25.4 = 0.6
          newFrom = {x: movingLine.from.x - delta, y: movingLine.from.y + delta};
          newTo = {x: movingLine.to.x + delta, y: movingLine.to.y - delta};
        }
        break;
      case orientation.SOUTHEAST:
        if (pointDistance2 < baseLineDistance) {
          const delta = (baseLineDistance - pointDistance2) / 4; //for ex. 26 - 25.4 = 0.6
          newFrom = {x: movingLine.from.x - delta, y: movingLine.from.y - delta};
          newTo = {x: movingLine.to.x + delta, y: movingLine.to.y + delta};
        } else {
          const delta = (pointDistance2 - baseLineDistance) / 4; //for ex. 26 - 25.4 = 0.6
          newFrom = {x: movingLine.from.x + delta, y: movingLine.from.y + delta};
          newTo = {x: movingLine.to.x - delta, y: movingLine.to.y - delta};
        }
        break;
      case orientation.NORTHEAST:
        if (pointDistance2 < baseLineDistance) {
          const delta = (baseLineDistance - pointDistance2) / 4; //for ex. 26 - 25.4 = 0.6
          newFrom = {x: movingLine.from.x - delta, y: movingLine.from.y + delta};
          newTo = {x: movingLine.to.x + delta, y: movingLine.to.y - delta};
        } else {
          const delta = (pointDistance2 - baseLineDistance) / 4; //for ex. 26 - 25.4 = 0.6
          newFrom = {x: movingLine.from.x + delta, y: movingLine.from.y - delta};
          newTo = {x: movingLine.to.x - delta, y: movingLine.to.y + delta};
        }
        break;
      case orientation.NORTHWEST:
        if (pointDistance2 < baseLineDistance) {
          const delta = (baseLineDistance - pointDistance2) / 4; //for ex. 26 - 25.4 = 0.6
          newFrom = {x: movingLine.from.x + delta, y: movingLine.from.y + delta};
          newTo = {x: movingLine.to.x - delta, y: movingLine.to.y - delta};
        } else {
          const delta = (pointDistance2 - baseLineDistance) / 4; //for ex. 26 - 25.4 = 0.6
          newFrom = {x: movingLine.from.x - delta, y: movingLine.from.y - delta};
          newTo = {x: movingLine.to.x + delta, y: movingLine.to.y + delta};
        }
        break;
      default:
        break;
    }
    setLinePoints(movingLine, newFrom, newTo);
  }
}
